export const ERRORS = { INVALID_JSON: 'Invalid JSON Object' };
